import o,{Component as e}from"react";import n from"prop-types";import t,{keyframes as i,css as r}from"styled-components";import{calculateRem as a,getOS as d}from"@vds-core/utilities";import{Fonts as p}from"@vds-core/typography";import s from"../util/AccordionAnimation.js";import{ColorTokens as l}from"@vds-tokens/color";import{TypographyTokens as c}from"@vds-tokens/typography";import{LayoutTokens as m}from"@vds-tokens/layout";const u=m.space["6X"].value,f=m.space["8X"].value,g=i`
  from {
    transform: translateY(0px);
  }

  to {
    transform: translateY(-16px);
  }
`,h=i`
  from {
    transform: translateY(20px);
  }

  to {
    transform: translateY(0px);
  }
`,y={opened:n.bool,children:n.node.isRequired,groupId:n.string,surface:n.oneOf(["light","dark"]),viewport:n.oneOf(["mobile","desktop","tablet"]),paddingTop:n.number,customChildrenTypography:n.bool,calcPaddingBottom:n.func},v={opened:!1,surface:"light",groupId:null,viewport:"desktop",paddingTop:6,calcPaddingBottom:function(o){return"mobile"===o?u:f}},b=t.div.withConfig({displayName:"ChildWrapper",componentId:"VDS__sc-19df7fd-0"})`
  ${function({opened:o}){return r`
      transition: padding 330ms linear;
      animation-name: ${o?h:g};
      animation-duration: 330ms;
      animation-delay: 100ms;
      animation-timing-function: linear;
    `}};
`,w=t.div.withConfig({displayName:"StyledAccordionDetail",componentId:"VDS__sc-19df7fd-1"})`
  padding-top: ${function({opened:o,paddingTop:e}){return o?a(e):0}};
  color: ${function({surface:o}){return"dark"===o?l.elements.primary.ondark.value:l.elements.primary.onlight.value}};
  ${function({viewport:o,customChildrenTypography:e}){return r`
    font-family: ${function(o,e){const n="mobile"===o;return e?p.VerizonNHGeDS:n?p.VerizonNHGeTX:p.VerizonNHGeDS}(o,e)};
    font-size: ${a(function(o,e){const n="mobile"===o;return e?c.fontsize.body[16].value:n?c.fontsize.body[12].value:c.fontsize.body[16].value}(o,e))};
    ${"mobile"!==o&&`\n      letter-spacing: ${a(c.letterspacing.wide.value)};`};
    line-height: ${a(function(o,e){const n="mobile"===o;return e?c.lineheight.body[20].value:n?c.lineheight.body[16].value:c.lineheight.body[20].value}(o,e))};
  `}}
  word-wrap: break-word;
  overflow-wrap: break-word;
  transition: padding 330ms;
  > * {
    margin: 0;
    &:not(:last-child) {
      margin-bottom: ${a(8)};
    }
  }
  &:active,
  &:hover {
    outline: none;
  }
  ${function({opened:o,paddingBottom:e}){return o&&`\n    padding-bottom: ${a(e)};\n    padding-top: 0;\n  `}};
`;class $ extends e{constructor(){super(...arguments),this.isAndroidDevice="undefined"!=typeof navigator&&navigator.userAgent.toLowerCase().indexOf("android")>-1,this.isIos="ios"===d()}componentDidMount(){const{groupId:o}=this.props;this.accordionDetailId=`accordionDetail_${o}`,this.accordionAliasId=`accordionHeaderLabel_${o}`}render(){const{opened:e,children:n,groupId:t,surface:i,viewport:r,paddingTop:a,customChildrenTypography:d,calcPaddingBottom:p}=this.props,l=e?"auto":0;return o.createElement(w,{viewport:r,opened:e,surface:i,id:this.accordionDetailId,"aria-labelledby":this.accordionAliasId,onClick:this._onClick,paddingTop:a,tabIndex:this.isIos||e?void 0:-1,role:"region","aria-hidden":!e&&!this.isIos,customChildrenTypography:d,paddingBottom:p(r)},o.createElement(s,{height:l,opened:e},o.createElement(b,{opened:e},n)))}}$.componentType="AccordionDetail",$.propTypes=y,$.defaultProps=v;export{$ as default};
